<template>
  <section>
    <div
      class="tw:flex tw:flex-col tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px] tw:py-6 tw:md:py-4 tw:lg:py-6 tw:lg:px-0 tw:mx-auto"
    >
      <h3
        v-if="withHeader"
        class="tw:font-bold tw:mx-auto tw:text-xl tw:text-blue-800 tw:mb-6 tw:text-center tw:md:text-left"
      >
        {{ $t('rc_mp_connectivity_providers') }}
      </h3>
      <div
        class="tw:flex tw:flex-row tw:flex-wrap tw:md:flex-nowrap tw:justify-around tw:md:justify-between tw:lg:mx-20"
      >
        <div v-for="logo in connectivityProviders" :key="logo.name" class="logo" :class="`logo_${logo.name}`">
          <img
            :src="logo.logo"
            :srcset="logo.srcset"
            :alt="logo.name"
            :width="logo.width"
            :height="logo.height"
            class="tw:mx-auto tw:max-h-[32px]"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  withHeader: Boolean,
})

// 1x versions (displayed size)
import webhotelier_logo from '@/assets/img/rate-connect-landing/logos/webhotelier-197w.png'
import dirs21_logo from '@/assets/img/rate-connect-landing/logos/dirs21-78w.png'
import roomcloud_logo from '@/assets/img/rate-connect-landing/logos/roomcloud-50w.png'
import beddy_logo from '@/assets/img/rate-connect-landing/logos/beddy-118w.png'
import wubook_logo from '@/assets/img/rate-connect-landing/logos/wubook-122w.png'

// 2x versions (retina)
import webhotelier_logo_2x from '@/assets/img/rate-connect-landing/logos/webhotelier-394w.png'
import dirs21_logo_2x from '@/assets/img/rate-connect-landing/logos/dirs21-156w.png'
import roomcloud_logo_2x from '@/assets/img/rate-connect-landing/logos/roomcloud-100w.png'
import beddy_logo_2x from '@/assets/img/rate-connect-landing/logos/beddy-236w.png'
import wubook_logo_2x from '@/assets/img/rate-connect-landing/logos/wubook-244w.png'

const connectivityProviders = [
  {
    logo: webhotelier_logo,
    srcset: `${webhotelier_logo} 1x, ${webhotelier_logo_2x} 2x`,
    name: 'Webhotelier',
    width: 197,
    height: 32,
  },
  {
    logo: dirs21_logo,
    srcset: `${dirs21_logo} 1x, ${dirs21_logo_2x} 2x`,
    name: 'Dirs21',
    width: 78,
    height: 32,
  },
  {
    logo: roomcloud_logo,
    srcset: `${roomcloud_logo} 1x, ${roomcloud_logo_2x} 2x`,
    name: 'RoomCloud',
    width: 50,
    height: 32,
  },
  {
    logo: beddy_logo,
    srcset: `${beddy_logo} 1x, ${beddy_logo_2x} 2x`,
    name: 'Beddy',
    width: 118,
    height: 32,
  },
  {
    logo: wubook_logo,
    srcset: `${wubook_logo} 1x, ${wubook_logo_2x} 2x`,
    name: 'Wubook',
    width: 122,
    height: 32,
  },
]
</script>

<style scoped>
.logo {
  @media (max-width: 767px) {
    flex: 50% 0 0;
    margin: auto;
    margin-top: 24px;
  }
}

.logo_Webhotelier {
  @media (max-width: 767px) {
    flex: 70% 0 0;
    margin-top: 0;
  }
}

.logo_Dirs21 {
  @media (max-width: 767px) {
    flex: 30% 0 0;
    margin-top: 0;
  }
}
</style>
